import styled, { css } from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export interface EventMetaStyledProps {
  $size?: 'small' | 'medium'
}

const sizeStyles = {
  small: css`
    font-size: ${({ theme }) => theme.typography.fontSize.label};

    .icon {
      width: 12px;
      height: 12px;
    }
  `,
  medium: css`
    font-size: ${({ theme }) => theme.typography.fontSize.micro};

    .icon {
      width: 14px;
      height: 14px;
    }
  `,
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<EventMetaStyledProps>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  line-height: ${({ theme }) => theme.typography.lineHeight.normal};

  .icon {
    flex-shrink: 0;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }

  ${({ $size = 'medium' }) => sizeStyles[$size]}

  ${media.tabletDown} {
    font-size: ${({ theme }) => theme.typography.fontSize.label};

    .icon {
      width: 12px;
      height: 12px;
    }
  }
`
